import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconStory$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStory extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '375f9f53bcbf2cc0ef3623ce88c6b8dde64d7829', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '97607ab0e2f5889bee4e99d5e9dde343909189d3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '39f6b72c5a8edeee7a1ff716764d328224038bb8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.5 3a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5zm12 1.5v13h-11v-13zm-8 5.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zM8 7.52a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5zm.5 5.96a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-story", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-story"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-story":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStory$1);
            }
            break;
    } });
}

const CosmosIconStory = CosmosIconStory$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStory, defineCustomElement };
